import { useEffect, useState } from "react";
import Button from "../../Custom/Button/Button";
import "./wraperCustom.css";
import DodavanjeKlijenta from "./DodavanjeKlijenta";
import DodavanjeKlijentaOpening from "./DodavanjeKlijentaOpening";
import ArhivirajIzmeniBtns from "./ArhivirajIzmeniBtns";
import AktivirajIzbrisiBtns from "./AktivirajIzbrisiBtns";

const WraperCustom = ({
  list,
  selected1,
  selected2,
  handleSelected1,
  handleSelected2,
  renderComponent,
  isShowAccounts,
  setIsShowAccounts,
  isOpening,
  openingType,
}) => {
  const [isDodavanjeKlijenta, setIsDodavanjeKlijenta] = useState(false);
  const [showArhivirani, setShowArhivirani] = useState(false);
  const [azuriranjeId, setAzuriranjeId] = useState("");
  const [arhiviranoId, setArhiviranoId] = useState("");

  console.log("WraperCustom isOpening:", isOpening);
  console.log("WraperCustom openingType:", openingType);

  const activeAccounts = list.filter(
    (account) => account.archived == 0 || !account.archived,
  );
  const archivedAccounts = list.filter((account) => account.archived == 1);

  useEffect(() => {
    if (activeAccounts && activeAccounts.length > 0) {
      handleSelected1(activeAccounts[0]);
    }
  }, []);

  const setTaskbar = () => {
    const taskbar = document.querySelector(".wraper-companies");
    const slidebar = document.querySelector(".button-arrow");
    if (!taskbar || !slidebar) return;
    // taskbar.style.height = ``;
  };

  window.addEventListener("resize", setTaskbar);

  useEffect(() => {
    setTaskbar();
  }, []);

  const handleToggleAddNewClient = () => {
    setIsDodavanjeKlijenta((prev) => !prev);
  };

  const handleToggleArhivirano = () => setShowArhivirani((prev) => !prev);

  const handleCancelDodavanje = () => {
    setIsDodavanjeKlijenta(false);
    setAzuriranjeId("");
  };

  const handleSelectArhiviran = (arhivirano) => {
    if (arhiviranoId) setArhiviranoId("");
    else setArhiviranoId(arhivirano.company_id);
  };

  const handleOpeningComplete = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete("opening");
    params.delete("type");
    window.history.replaceState(
      {},
      "",
      params.toString()
        ? `${window.location.pathname}?${params}`
        : window.location.pathname,
    );
    window.location.reload(); // reload da se ukloni opening state
  };

  if (!selected1) return <div className="wraper-companies"></div>;

  // Ako je opening mode, prikaži samo opening formu, ništa drugo
  if (isOpening && (openingType === 2 || openingType === 3)) {
    return (
      <div className="wraper-companies">
        <DodavanjeKlijentaOpening
          openingType={openingType}
          onComplete={handleOpeningComplete}
        />
      </div>
    );
  }

  return (
    <div className="wraper-companies">
      {isShowAccounts ? (
        <>
          {!isDodavanjeKlijenta &&
            !showArhivirani &&
            activeAccounts.map((item, index) => {
              const name = item.working_name || item.company_name;
              if (
                index === 0 ||
                (selected2 && item.company_id != selected2.company_id)
              )
                return null;
              return (
                <div className="button-taskbar-wrapper" key={index}>
                  <div className="button-taskbar">
                    <Button
                      active={
                        selected2 !== null &&
                        selected2.company_id == item.company_id
                      }
                      activation={selected1 === null}
                    >
                      {((selected1 === null && item.logo !== null) ||
                        (selected1 !== null &&
                          index === 0 &&
                          item.logo !== null)) && (
                        <img className="company-icon" src={item.logo} alt="" />
                      )}
                      <div
                        className={
                          selected1 === null && item.logo !== null
                            ? "company-icon-btn with-image"
                            : "company-icon-btn"
                        }
                        onClick={() => {
                          selected1 === null
                            ? handleSelected1(item)
                            : handleSelected2(item);
                          setIsDodavanjeKlijenta(false);
                          setShowArhivirani(false);
                          setAzuriranjeId("");
                        }}
                      >
                        {name.length < 20 ? name : `${name.slice(0, 20)}...`}
                      </div>
                    </Button>
                  </div>
                  {selected2?.company_id == item.company_id &&
                    !azuriranjeId && (
                      <>
                        {renderComponent()}
                        <ArhivirajIzmeniBtns
                          openAzuriranje={() =>
                            setAzuriranjeId(item.company_id)
                          }
                          companyId={item.company_id}
                        />
                      </>
                    )}
                </div>
              );
            })}

          {!selected2 && (
            <>
              {!showArhivirani && (
                <div className="button-taskbar-wrapper">
                  <div
                    className="button-taskbar"
                    onClick={handleToggleAddNewClient}
                  >
                    <Button
                      active={isDodavanjeKlijenta}
                      style={{ fontWeight: "bold" }}
                    >
                      + ДОДАЈ КЛИЈЕНТА
                    </Button>
                  </div>
                </div>
              )}
              {!isDodavanjeKlijenta && !arhiviranoId && (
                <div className="button-taskbar-wrapper">
                  <div
                    className="button-taskbar"
                    onClick={handleToggleArhivirano}
                  >
                    <Button
                      active={showArhivirani}
                      style={{ fontWeight: "bold" }}
                    >
                      АРХИВИРАНО
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}

          {(isDodavanjeKlijenta || azuriranjeId) && (
            <DodavanjeKlijenta
              azuriranjeId={azuriranjeId}
              handleCancel={handleCancelDodavanje}
            />
          )}

          {showArhivirani &&
            archivedAccounts.map((arhivirano, index) => {
              const name = arhivirano.working_name || arhivirano.company_name;
              if (!arhiviranoId || arhiviranoId == arhivirano.company_id)
                return (
                  <div className="button-taskbar-wrapper" key={index}>
                    <div
                      onClick={() => handleSelectArhiviran(arhivirano)}
                      className="button-taskbar"
                    >
                      <Button active={arhivirano.company_id === arhiviranoId}>
                        <div className="company-icon-btn">
                          {name.length < 20 ? name : `${name.slice(0, 20)}...`}
                        </div>
                      </Button>
                    </div>
                  </div>
                );
            })}
          {arhiviranoId && (
            <AktivirajIzbrisiBtns
              companyId={arhiviranoId}
              setArhiviranoId={setArhiviranoId}
            />
          )}
        </>
      ) : (
        <div className="button-taskbar-wrapper">
          <div
            className="button-taskbar"
            onClick={() => setIsShowAccounts(true)}
          >
            <Button style={{ fontSize: "4vh" }} activation={false}>
              КЛИЈЕНТИ
            </Button>
          </div>
          {renderComponent()}
        </div>
      )}
    </div>
  );
};

export default WraperCustom;